import ImageWrapper from '@components/image/Wrapper'
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc' // lib causing strict mode warnings TODO: upgrade when possible
import { useFileInputContext } from '@components/form/photos/FileInputContext'
// import arrayMove from 'array-move'

import styles from 'styles/add/SortableThumbnails.module.css'

const SortableItem = SortableElement(({ file, Actions, i }) =>
    <Thumb file={file} i={i} Actions={Actions} />)

const SortableList = SortableContainer(({ items, Actions }) =>
    <ul className={styles.thumbs}>
        { items.map((file, i) => (
            <SortableItem key={file.id || i} file={file} index={i} i={i} Actions={Actions} />
        )) }
    </ul>)

const SortableComponentThumbnails = ({ Actions }) => {
    const { files, setFiles,
        callbacks: { onFileOrderChange } = {}} = useFileInputContext()

    if (files?.length < 1) return null

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const newFiles = arrayMove(files, oldIndex, newIndex)
        setFiles(onFileOrderChange
            ? onFileOrderChange(newFiles)
            : newFiles)
    }

    return (
        <WrapInContext Actions={Actions}>
            <SortableList
                axis="xy"
                items={files}
                Actions={Actions.Actions}
                onSortEnd={onSortEnd}
                useDragHandle />
        </WrapInContext>
    )
}

function WrapInContext ({ Actions, children }) {
    return Actions?.ActionContext
        ? <Actions.ActionContext>
            { children }
          </Actions.ActionContext>

        : children
}

function Thumb ({ file, i, Actions }) {
    return (
        <div>
            <div className={styles.thumb}>
                <ImageWrapper>
                    <img
                        style={{ position: 'absolute', objectFit: 'cover', height: '100%', width: '100%', inset: 0 }}
                        src={file.preview}
                        alt={file.name} />
                </ImageWrapper>
            </div>
            { Actions && <Actions file={file} order={i} /> }
        </div>
    )
}

export default SortableComponentThumbnails